import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

// utils
import { capitalize } from '../../../utils/text';

// Services
import LocalStorageService from '../../../services/LocalStorageService'
import ReportService from '../../../services/ReportService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import DataTable from '../../../components/simple/dataTable/DataTable.js';
import Text from '../../../components/simple/text/Text'


// Font Awesome

import moment from 'moment'
import PulseLoader from 'react-spinners/PulseLoader.js'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js';
import FormService from '../../../services/FormService.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isServiceAdmin } from '../../../utils/permissions.js';


function Clickers (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [sort, setSort] = useState({
      property: 'clickerDate',
      direction: 'desc'
    })

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms')
    const params = useParams()
    const userId = params.userid

    const goBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        (async () => {
            if (!userId) { return }

            setLoading(true)
            await getData()
            setLoading(false)

            // setClickerValues(previousValues => ({
            // ...previousValues,
            // student: userId
            // }))

        })()
    }, [userId])

    const getData = async () => {
      // let searchType = 'concernreport'
      // // if (isServiceAdmin()) {
      // //   searchType = 'globalIncidentSearch'
      // // }

      const results = await ReportService.getReport(
        apiToken,
        {
          orgId: activeOrg.id,
          staffId: String(userId),

          // limit: 100,
          // page: 1
        },
        {
          submissionType: 'clicker',
          query: [
          //   {
          //     "key": "userId",
          //     "operator": "is",
          //     "response": userId,
          //     "relation": null
          //   }
          ],
          reports: ['staffClickerSearch'],
        },
      )

      if (results?.clickerSearch) {
        setData(results?.clickerSearch)
      }
    }

    const deleteReport = async submissionId => {
      if (window.confirm('Are you sure you want to delete this?')) {
        await FormService.updateSubmission(apiToken, submissionId, {
          status: 'Archived',
        });
        getData();
      }
    };

    const getClickerDateValue = datum => {
      if (datum?.clickerDate) {
        return datum.clickerDate
      }

      if (datum?.createdAt) {
        return moment(datum.createdAt).format('YYYY-MM-DD')
      }

      return ''
    }

    const formatClickerDate = value => {
      if (!value) {
        return ''
      }

      return moment(value).format('DD/MM/YYYY')
    }

    let suTerm = capitalize(terms?.serviceUser || 'Service User')


     const resultColumns = [
         {
             property: 'clickerDate',
             label: 'Date',
              header: <Text pad='none' margin='none' color='secondary' weight='800'>Date</Text>,
             render: datum => (
               <Text>{formatClickerDate(getClickerDateValue(datum))}</Text>
             )
           },
         {
           property: 'subType',
           label: 'Type',
           header: <Text pad='none' margin='none' color='secondary' weight='800'>Type</Text>
         },
         {
              property: 'actions',
              header: null,
              render: datum => (
                <>
                  <Box direction="row" width="100%">

                    {isServiceAdmin() && <ActionButton
                      plain
                      onClick={() => {
                        deleteReport(datum.id);
                      }}
                      children={
                        <Box pad="5px">
                          <FontAwesomeIcon
                            icon={['fal', 'trash']}
                            color="#ff8300"
                          />
                        </Box>
                      }
                    />}
                  </Box>

                </>
              )
            }
       ]



  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>
      <Box
        gap='small'
        round='small'
        margin={{ horizontal: 'small', top: 'small' }}
      >
        <DataTable
          columns={resultColumns}
          data={data}
          primaryKey="id"
          border={{ color: '#ddd' }}
          step={250}
          paginate={true}
          sort={sort}
          onSort={setSort}
        />
        {!data.length && <Text>There are no results to display.</Text>}
      </Box>
    </Box>
  )
}
export default Clickers
